module.exports = __webpack_public_path__ + "static/media/icons8-chrome-240.00a8e523.png";